<template>
  <div class="history-list-pc">
    <div v-if="record.length === 0 && !loading && !firstLoad" class="no-data">
      <i><img :src="$getThemeImagePath('no-data.png')" alt=""></i>
      <p>{{ $t('Bao.no_relevant_data_records') }}</p>
      <span>{{ $t('Bao.search_results_are_empty') }}</span>
    </div>
    <table v-else-if="record.length > 0" class="history-table historyWithdrawl">
      <thead>
        <tr>
          <th scope="col" class="text-center">
            {{ $t("Bao.status") }}
          </th>
          <th scope="col" class="text-center">
            {{ $t("Bao.time") }}
          </th>
          <th scope="col" class="text-center">
            {{ $t("Bao.withdrawal_for_record") }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in record" :key="key" class="goTo-data-popup" @click="showHistoryModal(item)">
          <td class="product">
            <div class="state-box">
              <span class="fs-14px">{{ item.status_label }}</span>
            </div>
          </td>
          <td class="index text-center">
            {{ item.formattedTime }}
          </td>
          <td class="ingredient">
            <div class="amount-container">
              <div class="amount-box text-center">
                <span class="fs-14px">{{ item.amount | numberFormat }}</span>
                <img class="his-icon" :src="item.image">
              </div><i class="fa-solid fa-angle-right" aria-hidden="true" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalHistory',
  props: {
    record: {
      type: Array,
      default: () => ([])
    },
    loading: {
      type: Boolean,
      default: false
    },
    firstLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    showHistoryModal(item) {
      this.$emit('show-history-modal', item)
    }
  }
}
</script>
